import beverages from './beverages.jpg'
import breakfast from './breakfast.jpg'
import main from './main.jpeg'
import outlay from './outlay.jpeg'
import logo from './logo.png'
import logoLight from './logo-light.png'

let images = {
    beverages,
    breakfast,
    main,
    outlay,
    logo,
    logoLight
}

export default images